module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/miyako_access_02-91319ae2e30816fa34c2219f2f58cd88.jpg";